var DealEventPipe, FreeShipping;

FreeShipping = window.FreeShipping != null ? window.FreeShipping : window.FreeShipping = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

FreeShipping.View = Backbone.View.extend({
  initialize: function() {
    this.$message = $('.free-shipping-container');
    DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateFreeShipping(priceData);
      };
    })(this));
    return DealEventPipe.on("touchDeliveryEstimatesUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateFreeShipping(priceData);
      };
    })(this));
  },
  updateFreeShipping: function(arg) {
    var uuid;
    uuid = arg.uuid;
    if (this.options.freeShippingValues[uuid]) {
      return this.$message.show();
    } else {
      return this.$message.hide();
    }
  }
});

module.exports = FreeShipping.View;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9zaGlwcGluZy9mcm9udGVuZC92aWV3cy9mcmVlX3NoaXBwaW5nLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvc2hpcHBpbmcvZnJvbnRlbmQvdmlld3MvZnJlZV9zaGlwcGluZy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxZQUFBLGlDQUFlLE1BQU0sQ0FBQyxlQUFQLE1BQU0sQ0FBQyxlQUFnQjs7QUFFdEMsYUFBQSxHQUFnQixPQUFBLENBQVEsbUNBQVI7O0FBRWhCLFlBQVksQ0FBQyxJQUFiLEdBQW9CLFFBQVEsQ0FBQyxJQUFJLENBQUMsTUFBZCxDQUNsQjtFQUFBLFVBQUEsRUFBWSxTQUFBO0lBQ1YsSUFBQyxDQUFBLFFBQUQsR0FBWSxDQUFBLENBQUUsMEJBQUY7SUFFWixhQUFhLENBQUMsRUFBZCxDQUFpQixhQUFqQixFQUFnQyxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsU0FBRDtlQUM5QixLQUFDLENBQUEsa0JBQUQsQ0FBb0IsU0FBcEI7TUFEOEI7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQWhDO1dBR0EsYUFBYSxDQUFDLEVBQWQsQ0FBaUIsOEJBQWpCLEVBQWlELENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxTQUFEO2VBQy9DLEtBQUMsQ0FBQSxrQkFBRCxDQUFvQixTQUFwQjtNQUQrQztJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBakQ7RUFOVSxDQUFaO0VBU0Esa0JBQUEsRUFBb0IsU0FBQyxHQUFEO0FBQ2xCLFFBQUE7SUFEb0IsT0FBRDtJQUNuQixJQUFHLElBQUMsQ0FBQSxPQUFPLENBQUMsa0JBQW1CLENBQUEsSUFBQSxDQUEvQjthQUNFLElBQUMsQ0FBQSxRQUFRLENBQUMsSUFBVixDQUFBLEVBREY7S0FBQSxNQUFBO2FBR0UsSUFBQyxDQUFBLFFBQVEsQ0FBQyxJQUFWLENBQUEsRUFIRjs7RUFEa0IsQ0FUcEI7Q0FEa0I7O0FBaUJwQixNQUFNLENBQUMsT0FBUCxHQUFpQixZQUFZLENBQUMifQ==
